import { Card, CardContent, CardProps, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props extends CardProps {
  children: ReactNode;
  onClick?: () => void;
  isSelected?: boolean;
  invalid?: boolean;
}

export const CardWithContent: FC<Props> = ({
  children,
  onClick,
  isSelected,
  invalid,
  ...rest
}) => {
  return (
    <Card
      {...rest}
      onClick={invalid ? undefined : onClick}
      sx={{
        boxShadow: (theme: Theme) =>
          isSelected
            ? `0px 0px 0px 1px ${theme.palette.primary.main}`
            : `0px 0px 0px 1px ${theme.palette.divider}`,
        cursor: invalid ? 'not-allowed' : onClick ? 'pointer' : 'default',
        mb: 2,
      }}>
      <CardContent
        sx={{
          alignItems: 'center',
          display: 'flex',
          '&:last-child': { pb: 2 },
          p: 2,
        }}>
        {children}
      </CardContent>
    </Card>
  );
};
